<template>
  <div class="containerFull_badmintonSudirman">
    <BadmintonCommon
      :bigSportsList="bigSportsList"
      :containerFullClassName="containerFullClassName"
      :defaultPath="defaultPath"
      :axiosBaseUrl="axiosBaseUrl"
      :sportCompetitionType="sportCompetitionType"
      :themeSeasonArr="themeSeasonArr"
    ></BadmintonCommon>
  </div>
</template>

<script>
// 羽毛球 苏迪曼杯 容器
import BadmintonCommon from './badminton_common'
import containerFull_data from '@mixins/badminton/sudirman/containerFull_data'
export default {
  name: 'containerFull_badmintonSudirman',
  mixins: [containerFull_data],
  components: {
    BadmintonCommon,
  },
}
</script>
